<template>
    <div>
        <el-steps style="margin-bottom:85px" class="applystep"  align-center :active="active" finish-status="success">
            <el-step title="基本信息"></el-step>
            <el-step title="本市住房信息"></el-step>
            <el-step title="添加附件"></el-step>
            <el-step title="完成"></el-step>
        </el-steps>
        <div class="apply-part" style="margin-bottom:53px">
            <div class="apply-part-title">
                <div class="blue-sign"></div>
                <span>本市户籍地住房</span>
            </div>
            <el-form
                style="margin-left:100px;padding:35px 0 14px 0;"
                label-width="150px"
                size="small"
                :rules="rules"
                :model="applyInfo.beCityEntity"
                :disabled="disabled"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="是否有本地户籍住房" prop="beCity">
                            <el-radio v-model="applyInfo.beCityEntity.beCity" :label="0">是</el-radio>
                            <el-radio v-model="applyInfo.beCityEntity.beCity" :label="1">否</el-radio>
                        </el-form-item>                    
                    </el-col>
                </el-row>
            </el-form>
            <div v-if="!applyInfo.beCityEntity.beCity">
            <el-form :inline="true" 
                style="margin-left:100px;padding:0 0 14px 0;"
                label-width="145px"
                size="small"
                :rules="rules"
                :model="applyInfo.beCityEntity"
                :disabled="disabled"
                ref="becity1"
            >
                <el-form-item prop="cityAdress" class="houseaddress" label="房屋坐落地址"><el-input maxlength="50" v-model="applyInfo.beCityEntity.cityAdress"></el-input></el-form-item>
                <el-form-item>
                    <el-select v-model="applyInfo.beCityEntity.cityAreaType">
                        <el-option
                        v-for="item in areatype"
                        :key="item.name"
                        :label="item.name"
                        :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="cityArea"><el-input maxlength="4" v-model="applyInfo.beCityEntity.cityArea"></el-input></el-form-item>
                <el-form-item ><span class="rightstar">平方米</span> </el-form-item>
            </el-form>
            <el-form
                style="margin-left:100px;padding:0 0 14px 0;"
                label-width="150px"
                size="small"
                :rules="rules"
                :model="applyInfo.beCityEntity"
                :disabled="disabled"
                ref="becity2"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="cityPropertyOwner" class="appinput" label="产权人或公房承租人">
                            <el-input maxlength="30" v-model="applyInfo.beCityEntity.cityPropertyOwner"></el-input>
                        </el-form-item>                    
                    </el-col>
                    <el-col :span="12">
                        <el-form-item class="appinput" label="该住房户籍人口总数" prop="cityPopulation">
                            <el-input maxlength="3" v-model="applyInfo.beCityEntity.cityPopulation"></el-input>
                        </el-form-item>                    
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="产权性质" prop='cityPropertyType'>
                            <el-select v-model="applyInfo.beCityEntity.cityPropertyType">
                                <el-option
                                v-for="item in propertytypelist"
                                :key="item.enumValue"
                                :label="item.enumText"
                                :value="item.enumValue">
                                </el-option>
                            </el-select>
                        </el-form-item>                    
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="房屋类型" prop='cityRoomType'>
                            <el-select v-model="applyInfo.beCityEntity.cityRoomType">
                                <el-option
                                v-for="item in housetypelist"
                                :key="item.enumValue"
                                :label="item.enumText"
                                :value="item.enumValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="21" class="addhouseremark">
                        <el-form-item  label="备注">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 5, maxRows: 10}"
                                maxlength="400"
                                v-model="applyInfo.beCityEntity.cityRemark">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            </div>
        </div>



        <div class="apply-part" style="margin-bottom:53px">
            <div class="apply-part-title">
                <div class="blue-sign"></div>
                <span>本区产权住房情况</span>
            </div>
            <el-form
                style="margin-left:100px;padding:35px 0 14px 0;"
                label-width="145px"
                size="small"
                :rules="rules"
                :model="applyInfo.beRegionEntity"
                :disabled="disabled"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="是否有本区住房" prop="beRegion">
                            <el-radio v-model="applyInfo.beRegionEntity.beRegion" :label="0">是</el-radio>
                            <el-radio v-model="applyInfo.beRegionEntity.beRegion" :label="1">否</el-radio>
                        </el-form-item>                    
                    </el-col>
                </el-row>
            </el-form>
            <div v-if="!applyInfo.beRegionEntity.beRegion">
            <el-form :inline="true" 
                style="margin-left:100px;padding:0 0 14px 0;"
                label-width="145px"
                size="small"
                :rules="rules"
                :model="applyInfo.beRegionEntity"
                :disabled="disabled"
                ref="beregion1"
            >
                <el-form-item prop="regionAdress" class="houseaddress" label="房屋坐落地址"><el-input maxlength="100" v-model="applyInfo.beRegionEntity.regionAdress"></el-input></el-form-item>
                <el-form-item>
                    <el-select v-model="applyInfo.beRegionEntity.regionAreaType">
                        <el-option
                        v-for="item in areatype"
                        :key="item.name"
                        :label="item.name"
                        :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="regionArea"><el-input maxlength="4"  v-model="applyInfo.beRegionEntity.regionArea"></el-input></el-form-item>
                <el-form-item ><span class="rightstar">平方米</span></el-form-item>
            </el-form>
            <el-form
                style="margin-left:100px;padding:0 0 14px 0;"
                label-width="150px"
                size="small"
                :rules="rules"
                :model="applyInfo.beRegionEntity"
                :disabled="disabled"
                ref="beregion2"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="regionPropertyOwner" class="appinput" label="产权人或公房承租人">
                            <el-input  maxlength="100"  v-model="applyInfo.beRegionEntity.regionPropertyOwner"></el-input>
                        </el-form-item>                    
                    </el-col>
                    <el-col :span="12">
                        <el-form-item class="appinput" label="该住房户籍人口总数" prop="regionPopulation">
                            <el-input maxlength="3"  v-model="applyInfo.beRegionEntity.regionPopulation"></el-input>
                        </el-form-item>                    
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="产权性质" prop="regionPropertyType">
                            <el-select v-model="applyInfo.beRegionEntity.regionPropertyType">
                                <el-option
                                v-for="item in propertytypelist"
                                :key="item.enumValue"
                                :label="item.enumText"
                                :value="item.enumValue">
                                </el-option>
                            </el-select>
                        </el-form-item>                    
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="房屋类型" prop="regionRoomType">
                            <el-select v-model="applyInfo.beRegionEntity.regionRoomType">
                                <el-option
                                v-for="item in housetypelist"
                                :key="item.enumValue"
                                :label="item.enumText"
                                :value="item.enumValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="21" class="addhouseremark">
                        <el-form-item  label="备注">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 5, maxRows: 10}"
                                 maxlength="400" 
                                v-model="applyInfo.beRegionEntity.regionRemark">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            </div>
        </div>


        <div class="apply-part" style="margin-bottom:53px">
            <div class="apply-part-title">
                <div class="blue-sign"></div>
                <span>承租本区公有住房情况</span>
            </div>
            <el-form
                style="margin-left:100px;padding:35px 0 14px 0;"
                label-width="145px"
                size="small"
                :rules="rules"
                :model="applyInfo.bePublicEntity"
                :disabled="disabled"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="是否有本区住房" prop="bePublic">
                            <el-radio v-model="applyInfo.bePublicEntity.bePublic" :label="0">是</el-radio>
                            <el-radio v-model="applyInfo.bePublicEntity.bePublic" :label="1">否</el-radio>
                        </el-form-item>                    
                    </el-col>
                </el-row>
            </el-form>
            <div v-if="!applyInfo.bePublicEntity.bePublic">
            <el-form :inline="true" 
                style="margin-left:100px;padding:0 0 14px 0;"
                label-width="145px"
                size="small"
                :rules="rules"
                :model="applyInfo.bePublicEntity"
                :disabled="disabled"
                ref="bepublic1"
            >
                <el-form-item prop="publicAdress" class="houseaddress" label="房屋坐落地址"><el-input maxlength="100"  v-model="applyInfo.bePublicEntity.publicAdress"></el-input></el-form-item>
                <el-form-item>
                    <el-select v-model="applyInfo.bePublicEntity.publicAreaType">
                        <el-option
                        v-for="item in areatype"
                        :key="item.name"
                        :label="item.name"
                        :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="publicArea"><el-input maxlength="4"  v-model="applyInfo.bePublicEntity.publicArea"></el-input></el-form-item>
                <el-form-item ><span class="rightstar">平方米</span></el-form-item>
            </el-form>
            <el-form
                style="margin-left:100px;padding:0 0 14px 0;"
                label-width="150px"
                size="small"
                :rules="rules"
                :model="applyInfo.bePublicEntity"
                :disabled="disabled"
                ref="bepublic2"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="publicPropertyOwner" class="appinput" label="产权人或公房承租人">
                            <el-input maxlength="100"  v-model="applyInfo.bePublicEntity.publicPropertyOwner"></el-input>
                        </el-form-item>                    
                    </el-col>
                    <el-col :span="12">
                        <el-form-item class="appinput" label="该住房户籍人口总数" prop="publicPopulation">
                            <el-input maxlength="3"  v-model="applyInfo.bePublicEntity.publicPopulation"></el-input>
                        </el-form-item>                    
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="产权性质" prop="publicPropertyType">
                            <el-select v-model="applyInfo.bePublicEntity.publicPropertyType">
                                <el-option
                                v-for="item in propertytypelist"
                                :key="item.enumValue"
                                :label="item.enumText"
                                :value="item.enumValue">
                                </el-option>
                            </el-select>
                        </el-form-item>                    
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="房屋类型" prop="publicRoomType">
                            <el-select v-model="applyInfo.bePublicEntity.publicRoomType">
                                <el-option
                                v-for="item in housetypelist"
                                :key="item.enumValue"
                                :label="item.enumText"
                                :value="item.enumValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="21" class="addhouseremark">
                        <el-form-item  label="备注">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 5, maxRows: 10}"
                                 maxlength="400" 
                                v-model="applyInfo.bePublicEntity.publicRemark">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            </div>
        </div>

        <div class="apply-part" style="margin-bottom:53px">
            <div class="apply-part-title">
                <div class="blue-sign"></div>
                <span>动迁安置补偿</span>
            </div>
            <el-form
                style="margin-left:100px;padding:35px 0 14px 0;"
                label-width="150px"
                size="small"
                :rules="rules"
                :model="applyInfo.haveCompensationEntity"
                :disabled="disabled"
                ref="haveCompensationEntity"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item class="overlabel" prop="haveCompensation">
                            <template #label>
                                <span>申 请 人 是 否 享 受 动迁安置(货币)补贴</span>
                            </template>
                            <el-radio v-model="applyInfo.haveCompensationEntity.haveCompensation" :label="true">是</el-radio>
                            <el-radio v-model="applyInfo.haveCompensationEntity.haveCompensation" :label="false">否</el-radio>
                        </el-form-item>                    
                    </el-col>
                </el-row>
                <div v-if="applyInfo.haveCompensationEntity.haveCompensation">
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="compensationArea" class="rightlabel" label="补偿面积">
                            <div style="display:flex">
                                <el-input maxlength="4"  v-model="applyInfo.haveCompensationEntity.compensationArea"></el-input>
                                <span style="margin-left:10px">平方米</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="动迁安置时间" class="rightlabel" prop="placementDate">
                            <el-date-picker
                                class="picker"
                                v-model="applyInfo.haveCompensationEntity.placementDate"
                                type="date"
                                :default-value="new Date(1990,0,1)">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="areaTotal" class="rightlabel" label="合计建筑面积">
                            <div style="display:flex">
                                <el-input maxlength="4"  v-model="applyInfo.haveCompensationEntity.areaTotal"></el-input>
                                <span style="margin-left:10px">平方米</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="compensationMoney" class="rightlabel" label="补偿金额">
                            <div style="display:flex">
                                <el-input maxlength="8"  v-model="applyInfo.haveCompensationEntity.compensationMoney"></el-input>
                                <span style="margin-left:10px">元</span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item class="rightlabel" label="人均建筑面积" prop="areaAvg">
                            <div style="display:flex">
                                <el-input maxlength="4"  v-model="applyInfo.haveCompensationEntity.areaAvg"></el-input>
                                <span style="margin-left:10px">平方米</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="populationTotal" class="rightlabel" label="核定面积家庭总人数">
                            <div style="display:flex">
                                <el-input maxlength="3"  v-model="applyInfo.haveCompensationEntity.populationTotal"></el-input>
                                <span style="margin-left:10px">人</span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                </div>
            </el-form>
        </div>

        <el-divider class="bottomdivider"></el-divider>
        <div style="text-align:center">
            <el-button style="background:#21A66D;color:#FFFFFF" @click="onPrevious">上一步</el-button>
            <el-button  type="primary" @click="onNext">下一步</el-button>
        </div>
    </div>
</template>

<script>
import UserApi from "@/api/user/index";
import { areaReg,isPositiveInt,isInt} from "@/helper/validate";
export default {
    data(){
        return{
            applyInfo:{
                beCityEntity:{
                    beCity: 1,
                    cityAdress: null,
                    cityArea: null,
                    cityPopulation: null,
                    cityPropertyOwner: null,
                    cityPropertyType: null,
                    cityRemark: null,
                    cityRoomType: null,
                    cityAreaType:null
                },
                beRegionEntity:{
                    beRegion: 1,
                    regionAdress: null,
                    regionArea: null,
                    regionPopulation: null,
                    regionPropertyOwner: null,
                    regionPropertyType: null,
                    regionRemark: null,
                    regionRoomType: null,
                    regionAreaType:null
                },
                bePublicEntity:{
                    bePublic: 1,
                    publicAdress: null,
                    publicArea: null,
                    publicPopulation: null,
                    publicPropertyOwner: null,
                    publicPropertyType: null,
                    publicRemark: null,
                    publicRoomType: null,
                    publicAreaType:null
                },
                haveCompensationEntity:{
                    areaAvg: null,
                    areaTotal: null,
                    compensationArea: null,
                    compensationMoney: null,
                    haveCompensation: false,
                    placementDate: null,
                    populationTotal: null,
                },
                rentBasicEntity:{
                    id:''
                },
            },
            disabled:false,
            rules:{
                beCity: [{ 
                    required: true,
                },],
                beRegion: [{ 
                    required: true,
                },],
                bePublic: [{ 
                    required: true,
                },],
                haveCompensation: [{ 
                    required: true,
                },],
                cityAdress: [{ 
                    required: true, 
                    message: "房屋坐落地址不可为空", 
                    trigger: "blur" 
                },],
                cityArea: [{ 
                    required: true, 
                    //message: "面积不可为空", 
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("面积格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur" 
                },],
                cityPropertyOwner: [{ 
                    required: true, 
                    message: "产权人或公房承租人不可为空", 
                    trigger: "blur" 
                },],
                regionAdress: [{ 
                    required: true, 
                    message: "房屋坐落地址不可为空", 
                    trigger: "blur" 
                },],
                regionArea: [{ 
                    required: true, 
                    //message: "面积不可为空", 
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("面积格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur" 
                },],
                regionPropertyOwner: [{ 
                    required: true, 
                    message: "产权人或公房承租人不可为空", 
                    trigger: "blur" 
                },],
                publicAdress: [{ 
                    required: true, 
                    message: "房屋坐落地址不可为空", 
                    trigger: "blur" 
                },],
                publicArea: [{ 
                    required: true, 
                    //message: "面积不可为空", 
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("面积格式不正确"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur" 
                },],
                publicPropertyOwner: [{ 
                    required: true, 
                    message: "产权人或公房承租人不可为空", 
                    trigger: "blur" 
                },],
                compensationArea: [{ 
                    required: true, 
                    //message: "补偿面积不可为空", 
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("补偿面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("补偿面积格式不正确"));
                        } else {
                            callback();
                        }
                    },

                    trigger: "blur" 
                },
                ],
                areaAvg:[{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("人均建筑面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("人均建筑面积格式不正确"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                cityPopulation:[{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("住房户籍人口总数不能为空！"));
                        } else if (!isInt(value)) {
                            callback(new Error("住房户籍人口总数输入格式不正确"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                regionPopulation:[{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("住房户籍人口总数不能为空！"));
                        } else if (!isInt(value)) {
                            callback(new Error("住房户籍人口总数输入格式不正确"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                publicPopulation:[{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("住房户籍人口总数不能为空！"));
                        } else if (!isInt(value)) {
                            callback(new Error("住房户籍人口总数输入格式不正确"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                cityPropertyType:[
                    {required: true, message: "产权性质不可为空"}
                ],
                regionPropertyType:[
                    {required: true, message: "产权性质不可为空"}
                ],
                publicPropertyType:[
                    {required: true, message: "产权性质不可为空"}
                ],
                cityRoomType:[
                    {required: true, message: "房屋类型不可为空"}
                ],
                regionRoomType:[
                    {required: true, message: "房屋类型不可为空"}
                ],
                publicRoomType:[
                    {required: true, message: "房屋类型不可为空"}
                ],
                placementDate: [{ 
                    required: true, 
                    message: "动迁安置时间不可为空", 
                    trigger: "blur" 
                },
                ],
                areaTotal: [{ 
                    required: true, 
                    //message: "合计建筑面积不可为空", 
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("合计建筑面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("合计建筑面积格式不正确"));
                        } else {
                            callback();
                        }
                    },

                    trigger: "blur" 
                },],
                compensationMoney: [{ 
                    required: true, 
                    //message: "补偿金额不可为空",
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("补偿金额不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("补偿金额不可为空格式不正确"));
                        } else {
                            callback();
                        }
                    }, 
                    trigger: "blur" 
                },],
                populationTotal: [{ 
                    required: true, 
                    //message: "核定面积家庭总人数不可为空", 
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("核定面积家庭总人数不可为空"));
                        } else if (!isPositiveInt(value)) {
                            callback(new Error("核定面积家庭总人数格式不正确"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur" 
                },],
                
            },
            areatype:[{
                name:'建筑面积',code:0
            },{
                name:'居住面积',code:1
            }],
            type:'',
            propertytypelist:[],
            housetypelist:[],
            active:1,

            fir:false,
            sec:false,
            thir:false,
            forth:false
        }
    },
    methods:{
        //获得产权性质列表
        getPropertyType(){
            this.propertytypelist = this.$Global.enum.BuildingPropertyType;
        },
        //获得房屋类型列表
        getHousingType(){
            this.housetypelist = this.$Global.enum.CityHousingType;
        },
        getApplyInfo(id){
            UserApi.getRentApplyInfo(id)
                .then(
                    (res) => {
                        
                        if(res.data.beCityEntity){
                            this.applyInfo=res.data
                        }
                        if(!res.data.eidtable){
                            this.disabled=true
                        }
                        this.getPropertyType()
                        this.getHousingType()
                    },
                    (err) => {
                    this.$message({
                        message: err,
                        center: true,
                    });
                    }
                )
                .catch((error) => {
                this.$message({
                    message: error,
                    center: true,
                });
            });
        },
        onNext(){
            if(this.disabled){
                this.$router.push({ path: '/Apply/ApplyThir' ,query: {id: this.$route.query.id}});
                return
            }
            this.fir=false
            this.sec=false
            this.thir=false
            this.forth=false
            if(!this.applyInfo.beCityEntity.beCity){
                this.$refs['becity1'].validate((valid) => {
                    if(valid){
                        this.$refs['becity2'].validate((valid) => {
                            if(valid){
                                this.fir=true
                            }
                        })
                    }
                })
            }else{
                this.fir=true
            }
            if(!this.applyInfo.beRegionEntity.beRegion){
                this.$refs['beregion1'].validate((valid) => {
                    if(valid){
                        this.$refs['beregion2'].validate((valid) => {
                            if(valid){
                                this.sec=true
                            }
                        })
                    }
                })
            }else{
                this.sec=true
            }
            if(!this.applyInfo.bePublicEntity.bePublic){
                this.$refs['bepublic1'].validate((valid) => {
                    if(valid){
                        this.$refs['bepublic2'].validate((valid) => {
                            if(valid){
                                this.thir=true
                            }
                        })
                    }
                })
            }else{
                this.thir=true
            }
            if(this.applyInfo.haveCompensationEntity.haveCompensation){
                this.$refs['haveCompensationEntity'].validate((valid) => {
                    if(valid){
                        this.forth=true
                    }
                })
            }else{
                this.forth=true
            }
            setTimeout(() => {
                if(this.fir&&this.sec&&this.thir&&this.forth){
                    UserApi.saveApply3(this.applyInfo)
                        .then(
                            () => {
                                if(this.$route.query.id){
                                    this.$router.push({ path: '/Apply/ApplyThir' ,query: {id: this.$route.query.id}});
                                }else{
                                    this.$router.push({ path: '/Apply/ApplyThir' });
                                }
                            },
                            (err) => {
                            this.$message({
                                message: err,
                                center: true,
                            });
                            }
                        )
                        .catch((error) => {
                        this.$message({
                            message: error,
                            center: true,
                        });
                    }); 
                }else{
                    this.fir=false
                    this.sec=false
                    this.thir=false
                    this.forth=false
                }
            },500)
        },
        onPrevious(){
            if(this.$route.query.id){
                this.$router.push({ path: '/Apply' ,query: {id: this.$route.query.id}});
            }else{
                this.$router.push({ path: '/Apply' });
            }
         },
    },
    props:['propObj'],
    activated(){
        this.getApplyInfo(this.$route.query.id)
        this.applyInfo.rentBasicEntity.id=this.$route.query.id     
    },
}
</script>

<style scoped>
span.rightstar::after {content: '* ';color: red;}
.apply-part{
    margin: 0 38px;
}
.apply-part-title{
    display: flex;
    align-items: center;
}
.blue-sign{
    width: 7px;
    height: 22px;
    background: #3B93EF;
    border: 1px solid #F1F1F1;
    border-radius: 3px;
}
.apply-part-title span{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    line-height: 18px;
    margin-left: 15px;
}
.houseaddress >>> .el-input__inner{
    width: 274px;
}
.appinput >>> .el-input__inner{
    width: 62%;
}
.picker>>>.el-input__inner{
    width: 97%;
}
.addhouseremark>>>.el-textarea__inner{
    width: 98.5%;
}
.overlabel >>> .el-form-item__label{
    line-height: 14px;
}
.rightlabel >>> .el-input{
    width: auto;
}
.bottomdivider{
    margin-top:75px
}
.applystep >>>.is-process .is-text{
    background: #21A66D;
    border: none;
    color: #fff;
}
.applystep >>>.is-wait .is-text{
    background: #D0D0D0;
    border: none;
    color: #fff;
}
.applystep >>>.is-success .el-step__line{
    background: #21A66D;
}
.applystep >>>.is-success .is-text{
    color: #21A66D;
    border-color:#21A66D;
}
.applystep >>>.el-step__line{
    height: 8px;
    top :6px;
}
.applystep >>>.el-step__title{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
</style>